import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Panel from '../../../../components/Panel';
import { createPortal } from "react-dom";
import { getPanelMaxHeight, getPanelMaxWidth, getPanelWidth } from '../../../../services/helper/panelSizeHelper';
import {
  getMultiSetupBufferData,
  applyMultiBufferUsageChange,
  getMultiInterfaceSetup,
  clearBufferData,
  createSweepByMultiBuffer
} from '../../store/multiInterface/action';
import BufferTable from "./bufferTable";
import { Button, Popover, Spin, Switch, Tooltip, Tree } from 'antd';
import sierraLibrary from '../../../../services/Sierra/library/libraryStorage';
import { IBIS, SPICE, VECTOR } from '../../../../constants/libraryConstants';
import { updateLibraryTree } from '../../store/library/action';
import multiSetupBufferDataBase from '../../../../services/Sierra/multiInterfaceSetup/multiSetupBufferDataBase';
import {
  FilterOutlined
} from '@ant-design/icons';
import { createSweepByMultiBufferExps } from '../../../../services/Sierra/multiInterfaceSetup/multiSetupCtrl';
import _ from "lodash"
import '../index.css';

class BufferEditPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxHeight: 0,
      maxWidth: 0,
      ibisList: sierraLibrary.getTree(IBIS),
      spiceList: sierraLibrary.getTree(SPICE),
      vectorList: sierraLibrary.getTree(VECTOR),
      expCheckedList: [],
      checkedVerificationIds: [],
      createTreeData: []
    }
    this.dialogRoot = document.getElementById("root");
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resize);
  }

  componentDidMount = () => {
    this.resize()
    window.addEventListener('resize', this.resize);
    this.props._getMultiSetupBufferData(this.props.verificationId)
  }

  componentDidUpdate = (prevProps) => {
    const { libraryTreeInfo, createSweepStatus } = this.props;
    if (libraryTreeInfo &&
      (!prevProps.libraryTreeInfo || libraryTreeInfo.length !== prevProps.libraryTreeInfo.length)
      && (libraryTreeInfo.includes(IBIS)
        || libraryTreeInfo.includes(SPICE)
        || libraryTreeInfo.includes(VECTOR))) {
      this.getLibraryList();
      this.props._updateLibraryTree(null);
    }
  }

  getLibraryList = () => {
    this.setState({
      ibisList: sierraLibrary.getTree(IBIS),
      spiceList: sierraLibrary.getTree(SPICE),
      vectorList: sierraLibrary.getTree(VECTOR)
    })
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxHeight: getPanelMaxHeight(offset, 800),
      maxWidth: getPanelMaxWidth(offset, 1300)
    })
  }

  closeModal = () => {
    this.props.save && this.props.save();
    this.props.closePanel && this.props.closePanel();
    this.props._getMultiInterfaceSetup()
    this.props._clearBufferData()
  }

  updateExpCheckedList = (expCheckedList) => {
    multiSetupBufferDataBase.initInterfaceList(expCheckedList);
    const list = multiSetupBufferDataBase.getInterfaceList();
    const checkedVerificationIds = list.map(item => item.key)
    this.setState({
      expCheckedList,
      checkedVerificationIds
    })
  }

  checkVerifications = (checkedKeys, list) => {
    let keys = [...checkedKeys]
    if (checkedKeys.includes("All")) {
      keys = list[0].children.map(item => item.key)
    }
    this.setState({
      checkedVerificationIds: keys
    })
  };

  loadingCreateMenu = async () => {
    const { expCheckedList, checkedVerificationIds, createTreeInfo, createTreeData } = this.state;
    const { currentProjectId } = this.props;
    let _checkedVerificationIds = [...checkedVerificationIds];
    let treeData = [];
    this.setState({
      createTreeInfo: { ...createTreeInfo, loading: expCheckedList.length ? true : false },
      checkedVerificationIds: ["All"]
    }, async () => {
      if (!createTreeInfo
        || !_.isEqual(expCheckedList, createTreeInfo.expCheckedList || [])) {
        multiSetupBufferDataBase.initInterfaceList(expCheckedList)
        const interfaceList = multiSetupBufferDataBase.getInterfaceList();
        const checkedVerIds = interfaceList.map(item => item.key)
        const interfaceSweepMap = expCheckedList.length && checkedVerIds.length ? await createSweepByMultiBufferExps({
          projectId: currentProjectId,
          selectedKeys: [...expCheckedList],
          selectedVerifications: [...checkedVerIds],
          create: false
        }) : {};
        treeData = interfaceList.length ? [{
          title: "All",
          key: "All",
          children: interfaceList.map(item => {
            item.children = (interfaceSweepMap[item.key] || []).map(it => { return { key: `${item.key}::${it}`, title: it, checkable: false } });
            return item;
          }).filter(item => !!item.children.length)
        }] : [];
        _checkedVerificationIds = Object.keys(interfaceSweepMap || {});
      } else {
        treeData = createTreeData;
      }

      this.setState({
        createTreeData: treeData,
        createTreeInfo: { expCheckedList: [...expCheckedList], loading: false },
        checkedVerificationIds: _checkedVerificationIds
      })
    })
  }

  getMenu = () => {
    const { checkedVerificationIds, createTreeData, createTreeInfo } = this.state;
    return <div>
      <Spin spinning={createTreeInfo && createTreeInfo.loading ? true : false} tip="Loading data..." size="small">
        {/* <div>Create Sweep experiments by model experiments</div> */}
        {createTreeData.length ? <Tree
          checkable
          selectable={false}
          defaultExpandAll
          checkedKeys={checkedVerificationIds}
          onCheck={(checkedKeys) => this.checkVerifications(checkedKeys, createTreeData)}
          treeData={createTreeData}
        />
          : <div className='sierra-multi-buffer-create-text'>
            Please select the experiments
          </div>}
      </Spin>
    </div>
  }

  getFooter = () => {
    const { createSweepStatus, createSweepMsg } = this.props;
    const { createTreeInfo, expCheckedList } = this.state;
    const msgClassName = createSweepMsg && createSweepMsg.includes("successfully") ? "sierra-multi-buffer-create-sweep-message-success-span" : "sierra-multi-buffer-create-sweep-message-error-span"
    return <div className="sierra-multi-buffer-footer-content">
      {createSweepMsg ? <Tooltip
        title={createSweepMsg}
        classNames={{ root: "aurora-tooltip" }}>
        <div className={`sierra-multi-buffer-create-sweep-message-span ${msgClassName}`} title={createSweepMsg}>{createSweepMsg}</div>
      </Tooltip> : null}
      <Popover content={this.getMenu()}
        title="Filter interfaces to create sweep"
        placement="leftTop"
        classNames={{ root: createTreeInfo && createTreeInfo.loading ? "sierra-multi-buffer-loading-popover sierra-multi-buffer-popover" : "sierra-multi-buffer-popover" }}
        trigger="click">
        <FilterOutlined
          className="sierra-multi-buffer-filter-icon"
          title="Filter interfaces"
          onClick={createSweepStatus ? null : (e) => this.loadingCreateMenu(e)}
        />
      </Popover>
      <Tooltip
        title="Create Sweep experiments">
        <Button
          type="primary"
          title="Create Sweep experiments by model experiments"
          onClick={(e) => this.createSweep(e)}
          loading={createSweepStatus || false}
          disabled={expCheckedList.length ? false : true}
        >Create</Button>
      </Tooltip>
    </div>
  }

  createSweep = (e) => {
    e && e.stopPropagation();
    const { checkedVerificationIds, expCheckedList } = this.state;
    if (!checkedVerificationIds.length || !expCheckedList.length) {
      return;
    }
    let _checkedVerificationIds = [...checkedVerificationIds]
    if (checkedVerificationIds[0] === "All") {
      multiSetupBufferDataBase.initInterfaceList(expCheckedList);
      const list = multiSetupBufferDataBase.getInterfaceList();
      _checkedVerificationIds = list.map(item => item.key)
    }
    this.props._createSweepByMultiBuffer(_checkedVerificationIds, expCheckedList);
  }

  render() {
    const { loading, usageApplyAll, interfaceName, createSweepMsg } = this.props;
    const { maxWidth, maxHeight, ibisList, spiceList, vectorList, expCheckedList } = this.state;
    const width = getPanelWidth(maxWidth, { defaultWidth: 1300 });
    const content = (
      <Fragment>
        <Panel
          title={`${interfaceName ? `${interfaceName} ` : ""}Buffer Model`}
          className='sierra-multi-buffer-panel sierra-panel'
          position='panel-center-top'
          minHeight={200}
          minWidth={100}
          width={width}
          maxHeight={maxHeight}
          maxWidth={maxWidth}
          onCancel={() => { this.closeModal() }}
          footer={this.getFooter()}
          draggable
          zIndex={2000}
        >
          <div className="multi-buffer-content" id="multi-buffer-content-id">
            <Spin spinning={loading} tip={'Loading...'}>
              <div className='sierra-multi-buffer-content'>
                <div className="sierra-multi-buffer-copy-usage">
                  <span>Apply the same usage setting to all the pins in the component</span>
                  <Switch
                    size="small"
                    className="aurora-switch-small sierra-multi-buffer-copy-usage-switch"
                    checked={usageApplyAll}
                    onChange={this.props.applyUsageChange}
                  />
                </div>
                <BufferTable
                  ibisList={ibisList}
                  spiceList={spiceList}
                  vectorList={vectorList}
                  panelWidth={width}
                  panelHeight={maxHeight}
                  expCheckedList={expCheckedList}
                  updateExpCheckedList={this.updateExpCheckedList}
                />
              </div>
            </Spin>
          </div>
        </Panel>
      </Fragment>
    );
    return createPortal(content, this.dialogRoot)
  }

}

const mapState = (state) => {
  const { SierraReducer: { multiInterfaceSetup: { bufferData, createSweepStatus, createSweepMsg }, library: { libraryTreeInfo }, project: { currentProjectId } } } = state;
  const { loading, usageApplyAll } = bufferData || {};
  return {
    loading,
    usageApplyAll,
    libraryTreeInfo,
    createSweepStatus,
    currentProjectId,
    createSweepMsg
  }
}

const mapDispatch = (dispatch) => ({
  _getMultiSetupBufferData(verificationId) {
    dispatch(getMultiSetupBufferData(verificationId))
  },
  applyUsageChange(checked) {
    dispatch(applyMultiBufferUsageChange(checked))
  },
  _getMultiInterfaceSetup() {
    dispatch(getMultiInterfaceSetup())
  },
  _clearBufferData() {
    dispatch(clearBufferData())
  },
  _updateLibraryTree(type) {
    dispatch(updateLibraryTree(type))
  },
  _createSweepByMultiBuffer(verificationIds, checkedExps) {
    dispatch(createSweepByMultiBuffer(verificationIds, checkedExps))
  }
})

export default connect(mapState, mapDispatch)(BufferEditPanel);
